<template>
  <BaseModal
    :isShow="isSuccessModalShowState"
    @close="closeModal"
    size="sm"
  >
    <div
      class="flex flex-col w-full p-6 gap-4 text-black text-center text-lg font-bold"
    >
      <div>اطلاعات شما با موفقیت ثبت شد.</div>
      <div>کارشناسان ما به زودی با شما تماس خواهند گرفت.</div>
      <div>
        <BaseButton
          @click="closeModal"
          isLean
          size="md"
          text="باشه"
          id="success_submit"
          :class="successModalBtnClass"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
const isSuccessModalShowState = useState('isSuccessModalShowState')
const successModalBtnClass = useState('successModalBtnClass')

const closeModal = () => {
  successModalBtnClass.value = ''
  isSuccessModalShowState.value = false
}
</script>
